export default function doesFilterNameExist(userPreferenceFilters, filterName, filterId) {
    if (filterId) {
        const existingFilterNames = userPreferenceFilters
            .filter((f) => f.id !== filterId)
            .map((f) => f.filterName.replaceAll(' ', ''));

        return existingFilterNames.includes(filterName.replaceAll(' ', ''));
    }

    const existingFilterNames = userPreferenceFilters.map((f) => f.filterName.replaceAll(' ', ''));
    return existingFilterNames.includes(filterName.replaceAll(' ', ''));
}
